module.exports = __webpack_public_path__ + "media/images/bonusForSharing__bg-1f18f6a748e6bcabefc461de4397faa1.jpg";